<template>
    <div
        class="row flex-row"
        v-if="stores.length > 0"
        :class="{ 'row--fullwidth': this.isMapOnly, is_details: this.isDetail, is_static: isStatic }">
        <div class="col lg-6 sm-12" v-if="isList">
            <div
                class="store text_11"
                v-for="(store, index) in stores"
                :key="store.id"
                :data-index="index"
                @mouseenter="setActiveIcon(index)"
                @mouseleave="unsetActiveIcon(index)">
                <div class="store__title">{{ store.name }}</div>
                <div class="store__address color-text_3">{{ store.metro.station }}, {{ store.address }}</div>
                <div class="store__address">
                    <span class="color-text_3" v-for="(working_hours, index) in store.working_hours" :key="index"
                        >{{ working_hours.day }} {{ working_hours.time }}
                        <span v-if="store.phones[0] || index !== store.working_hours.length - 1">/ </span>
                    </span>
                    <span v-if="store.phones[0]"
                        ><a :href="'tel:' + store.phones[0].replace(/\s/g, '')" class="color-text_1">{{
                            store.phones[0]
                        }}</a></span
                    >
                </div>
            </div>
        </div>

        <div class="col lg-6 sm-12 col--no-padding" v-if="isDetail">
            <div class="modal-detail">
                <div class="modal-detail__header">
                    <div class="modal-detail__row text_13">
                        <div>{{ detail.store.name }}</div>
                        <div>{{ $t("free") }}</div>
                    </div>
                    <div class="modal-detail__row color-text_2 text_11">
                        <div>{{ detail.store.metro.station }}, {{ detail.store.address }}</div>
                        <div>
                            {{ detail.delivery_days ? detail.delivery_days + ", " : ""
                            }}{{ detail.fitting ? fitting : "" }}
                        </div>
                    </div>
                </div>
                <div class="modal-detail__content color-text_2">
                    <div class="modal-detail__row modal-detail__row--lined">
                        <div>{{ $t("open_hours") }}</div>
                        <div>{{ detail.store.working_hours[0].day }} {{ detail.store.working_hours[0].time }}</div>
                    </div>

                    <div class="modal-detail__row modal-detail__row--lined">
                        <div>{{ $t("payment") }}</div>
                        <div>
                            <span v-for="(pay, index) in detail.payment_types" :key="pay.id">
                                {{ pay.name }}{{ index == detail.payment_types.length - 1 ? "" : ", " }}
                            </span>
                        </div>
                    </div>

                    <div class="modal-detail__row modal-detail__row--lined">
                        <div>{{ $t("return") }}</div>
                        <div>{{ detail.return ? yes_return : no_return }}</div>
                    </div>

                    <div class="modal-detail__row modal-detail__row--lined">
                        <div>{{ $t("phone") }}</div>
                        <a
                            v-if="store.phones[0]"
                            :href="'tel:' + detail.store.phones[0].replace(/\s/g, '')"
                            class="color-text_1"
                            >{{ detail.store.phones[0] }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="col sm-12 col--no-padding" :class="{ 'lg-12': this.isMapOnly, 'lg-6': !this.isMapOnly }">
            <div id="map">
                <template v-if="mapSettings">
                    <yandex-map
                        @map-was-initialized="setMap"
                        :coords="mapSettings.center"
                        :zoom="mapSettings.zoom"
                        :controls="mapSettings.controls">
                        <ymap-marker
                            v-for="(marker, index) in markers"
                            :coords="marker.coord"
                            :icon="marker.icon"
                            :marker-id="index"
                            :key="index" />
                    </yandex-map>
                </template>
                <div class="zoom">
                    <div class="zoom__in" @click="map.setZoom(map.getZoom() + 1)">
                        <svg-icon name="plus--large" width="15" height="15" />
                    </div>
                    <div class="zoom__out" @click="map.setZoom(map.getZoom() - 1)">
                        <svg-icon name="minus--large" width="15" height="15" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { loadYmap } from "vue-yandex-maps";
export default {
    name: "StoresMap",
    props: {
        isStatic: {
            type: Boolean,
            default() {
                return false;
            },
        },
        stores: {
            type: Array,
            default() {
                return [];
            },
        },
        isList: {
            type: Boolean,
            default() {
                return false;
            },
        },
        isMapOnly: {
            type: Boolean,
            default() {
                return false;
            },
        },
        isDetail: {
            type: Boolean,
            default() {
                return false;
            },
        },
        activeMarkerIndex: {
            type: [Number, Boolean],
            default() {
                return false;
            },
        },
        detail: {
            type: Object,
        },
    },
    data() {
        return {
            ymaps: null,
            icon: {
                layout: "default#image",
                imageHref: "https://post-post-scriptum.com/img/crystal.svg",
                imageSize: [16, 16],
                imageOffset: [-8, -8],
            },
            iconHover: {
                layout: "default#image",
                imageHref: "https://post-post-scriptum.com/img/crystal.svg",
                imageSize: [24, 24],
                imageOffset: [-12, -12],
            },
            markers: null,
            map: null,
        };
    },
    computed: {
        fitting() {
            return this.$i18n.t("fitting");
        },
        yes_return() {
            return this.$i18n.t("yes_return");
        },
        no_return() {
            return this.$i18n.t("no_return");
        },
        mapSettings() {
            if (this.ymaps) {
                let mapElement = document.getElementById("map");
                let markerCoords = [];
                for (const key in this.markers) {
                    if (this.markers.hasOwnProperty(key)) {
                        const element = this.markers[key];
                        markerCoords.push(element.coord);
                    }
                }
                let centerAndZoom = this.ymaps.util.bounds.getCenterAndZoom(
                    this.ymaps.util.bounds.fromPoints(markerCoords),
                    [mapElement.offsetWidth, mapElement.offsetHeight]
                );
                return {
                    center: this.markers.length > 1 ? centerAndZoom.center : this.markers[0].coord,
                    zoom: this.markers.length > 1 ? centerAndZoom.zoom : 12,
                    controls: [],
                };
            }
            return false;
        },
    },
    watch: {
        activeMarkerIndex() {
            for (let index = 0; index < this.markers.length; index++) {
                const element = this.markers[index];
                if (index == this.activeMarkerIndex) {
                    element.icon = this.iconHover;
                } else {
                    element.icon = this.icon;
                }
            }
        },
    },
    methods: {
        setActiveIcon(index) {
            this.markers[index].icon = this.iconHover;
        },
        unsetActiveIcon(index) {
            this.markers[index].icon = this.icon;
        },
        setMap(map) {
            this.map = map;
        },
    },
    async mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
        await loadYmap({
            apiKey: "0fe09a79-7c31-4723-9b82-6af67e4c9487",
            lang: "ru_RU",
            coordorder: "latlong",
            version: "2.1",
        });
        this.ymaps = ymaps;
        let markers = [];
        let index = 0;
        for (const shop in this.stores) {
            if (this.stores.hasOwnProperty(shop)) {
                const element = this.stores[shop];
                markers.push({
                    coord: [element.lat, element.long],
                    icon:
                        this.activeMarkerIndex >= 0
                            ? this.activeMarkerIndex == index
                                ? this.iconHover
                                : this.icon
                            : this.icon,
                });
                ++index;
            }
        }
        this.markers = markers;
    },
};
</script>
<style lang="less" scoped>
.zoom {
    position: absolute;
    z-index: 3;
    right: 16px;
    top: 50%;
    margin-top: -39px;
    div {
        width: 39px;
        height: 39px;
        border: 1px #000 solid;
        display: flex;
        align-items: center;
        justify-content: center;
        .trs(all);
        background: #fff;
        cursor: pointer;
        svg {
            display: block;
        }
        + div {
            margin-top: -1px;
        }
        &:hover {
            background: @accent;
            border-color: @accent;
            color: #fff;
        }
    }
}
.ymap-container {
    height: 100%;
    width: 100%;
    border-left: 1px solid @border2;
    margin-left: -1px;
    .is_static & {
        position: absolute;
        top: 0;
        left: 0;
    }
}
.store {
    margin: 0 -32px;
    padding: 25px 32px;
    border-bottom: 1px solid @border2;
    cursor: pointer;
    .trs(background);
    @media @sm {
        margin: 0 -16px;
    }
    &:hover {
        background: #fff;
    }
    &__title {
        margin-bottom: 12px;
    }
    &__info {
        margin-top: 4px;
    }
    &__address {
        margin-top: 4px;
    }
}
.row {
    @media @sm {
        flex-direction: column;
        .col--no-padding:not(:first-child) {
            flex-grow: 1;
            position: relative;
        }
    }
}
.is_details {
    height: 100%;
}
#map {
    height: calc(100dvh - 108px);
    min-height: 100%;
    .is_details & {
        height: 100%;
        flex-grow: 1;
        min-height: auto;
        position: relative;
        .ymap-container {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }
    @media @sm {
        position: absolute;
        height: auto;
        min-height: 100vw;
        border-left: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border-bottom: 1px solid @border2;
        .is_static & {
            position: relative;
            border-bottom: 0;
        }
    }
}
.modal-detail {
    &__header {
        padding: 32px;
        padding-bottom: 140px;
        border-bottom: 1px solid @border2;
        .modal-detail__row + .modal-detail__row {
            margin-top: 8px;
        }
        @media @sm {
            padding: 32px 16px;
        }
    }
    &__row {
        display: flex;
        justify-content: space-between;
        div {
            width: 50%;
        }
        div + div {
            text-align: right;
            padding-left: 20px;
        }
        &--lined {
            padding: 12px 0;
            & + & {
                border-top: 1px solid @border2;
            }
        }
    }
    &__content {
        padding: 20px 32px 32px;
        @media @sm {
            padding: 20px 16px 32px;
        }
        a {
            color: #000;
        }
    }
}
</style>
